import { render, staticRenderFns } from "./TeachersViewInfo.vue?vue&type=template&id=34c7834c&v-if=teacher"
import script from "./TeachersViewInfo.vue?vue&type=script&lang=js"
export * from "./TeachersViewInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports